export default {
  getContractsListOptions: state => state.contractsListOptions,
  getSelectedContract: state => state.selectedContract,
}
